export * from './app.component';

// export * from './app.module';